import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { BhLandLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';

interface BhLandProps {
    label?: string;
    disabled?: boolean;
    value: string;
    menuPlacement?: MenuPlacement;
    allowEmpty?: boolean;
    renderLabel?: 'label' | 'placeholder' | 'no';
    onChange?: (newValue: string) => void;
}

export const BhLand: React.FC<BhLandProps> = ({
    label = 'BH Land',
    value,
    disabled = false,
    menuPlacement = 'bottom',
    allowEmpty = false,
    renderLabel = 'label',
    onChange,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];

        Object.keys(BhLandLabel).forEach((key) => {
            list.push({
                value: key,
                label: BhLandLabel[key],
            });
        });

        if (allowEmpty) {
            list.push({ value: '', label: '' });
        }

        return list;
    }, [allowEmpty]);

    const selectedOption = React.useMemo(() => {
        if (value) {
            return {
                value,
                label: BhLandLabel[value] || value,
            };
        }

        return {
            value: '',
            label: '',
        };
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>{label}</Label>}
            <Select
                name="status"
                isDisabled={disabled}
                isClearable={allowEmpty}
                value={selectedOption}
                options={options}
                menuPlacement={menuPlacement}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    if (onChange) {
                        onChange(option?.value || '');
                    }
                }}
                placeholder={renderLabel === 'placeholder' ? 'Status' : ''}
            />
        </>
    );
};
